import React, { useState, useEffect } from 'react';
import { 
  ArrowLeft, ShoppingBag, Search, Filter,
  Coffee, Utensils, PaintBucket, Package
} from 'lucide-react';
import ProductCard from '../common/ProductCard';
import CategoryButton from '../common/CategoryButton';
import recomendedProducts from '../../dados/recomendedProducts';
import { saveProduct } from '../../store/useProduct';

const ShopScreen = ({ setActiveScreen }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProducts, setFilteredProducts] = useState(recomendedProducts);

  function handleProductClick(product) {
    saveProduct(product)
    setActiveScreen('product')
  }

  function handleCategoryClick(category) {
    setActiveCategory(category);
  }

  function handleSearchChange(e) {
    setSearchQuery(e.target.value);
  }

  useEffect(() => {
    // Filter products based on both category and search query
    let filtered = [...recomendedProducts];
    
    // Apply category filter
    if (activeCategory !== 'all') {
      filtered = filtered.filter(product => product.category === activeCategory);
    }
    
    // Apply search filter
    if (searchQuery.trim() !== '') {
      const searchTerms = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(product => 
        product.title.toLowerCase().includes(searchTerms) || 
        product.description?.toLowerCase().includes(searchTerms)
      );
    }
    
    setFilteredProducts(filtered);
  }, [activeCategory, searchQuery]);

  return (
  <div className="p-4">
    <div className="flex items-center mb-4">
      <ArrowLeft size={20} className="mr-2 cursor-pointer" onClick={() => setActiveScreen('home')} />
      <h2 className="text-xl font-bold text-gray-800">Loja Gramopool</h2>
    </div>
    
    {/* Banner de promoção */}
    <div className="bg-gradient-to-r from-[#068cb0] to-[#033f4f] rounded-xl p-4 shadow-md mb-6 relative overflow-hidden">
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-[#028090] flex items-center justify-center">
        <ShoppingBag size={40} className="text-white opacity-50" />
      </div>
      <div className="max-w-[70%]">
        <h3 className="text-white text-lg font-semibold mb-1">Semana de Ofertas</h3>
        <p className="text-green-100 text-sm mb-2">Descontos especiais em produtos para seu jardim</p>
        <button className="bg-white text-green-600 px-3 py-1 rounded-lg text-sm font-medium">
          Ver ofertas
        </button>
      </div>
    </div>
    
    {/* Barra de pesquisa e filtros */}
    <div className="flex mb-6">
      <div className="flex-1 bg-white rounded-l-lg border border-gray-200 flex items-center px-3 py-2">
        <Search size={18} className="text-gray-400 mr-2" />
        <input 
          type="text" 
          placeholder="Buscar produtos..." 
          className="w-full outline-none text-sm"
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>
      <button className="bg-white border border-l-0 border-gray-200 rounded-r-lg px-3 flex items-center">
        <Filter size={18} className="text-gray-600" />
      </button>
    </div>
    
    {/* Categorias */}
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Categorias</h3>
      <div className="flex space-x-3 overflow-x-auto pb-2">
        <div onClick={() => handleCategoryClick('all')} className="cursor-pointer">
          <CategoryButton 
            icon={<Package />} 
            text="Todos" 
            isActive={activeCategory === 'all'} 
          />
        </div>
        <div onClick={() => handleCategoryClick('consumiveis')} className="cursor-pointer">
          <CategoryButton 
            icon={<Coffee />} 
            text="Consumíveis" 
            isActive={activeCategory === 'consumiveis'} 
          />
        </div>
        <div onClick={() => handleCategoryClick('utensilios')} className="cursor-pointer">
          <CategoryButton 
            icon={<Utensils />} 
            text="Utensílios" 
            isActive={activeCategory === 'utensilios'} 
          />
        </div>
        <div onClick={() => handleCategoryClick('decoracoes')} className="cursor-pointer">
          <CategoryButton 
            icon={<PaintBucket />} 
            text="Decorações" 
            isActive={activeCategory === 'decoracoes'} 
          />
        </div>
        <div onClick={() => handleCategoryClick('conjuntos')} className="cursor-pointer">
          <CategoryButton 
            icon={<Package />} 
            text="Conjuntos" 
            isActive={activeCategory === 'conjuntos'} 
          />
        </div>
      </div>
    </div>
    
    {/* Produtos em destaque */}
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        {activeCategory === 'all' && searchQuery === '' ? 'Produtos em Destaque' : 
         searchQuery !== '' ? `Resultados da busca: "${searchQuery}"` :
         `Categoria: ${activeCategory.charAt(0).toUpperCase() + activeCategory.slice(1)}`}
      </h3>
      
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product, index) => (
            <ProductCard
              key={index}
              image={product.image}
              title={product.title}
              description={product.description}
              price={product.price}
              discount={product.discount}
              rating={product.rating}
              icon={product.icon}
              onClick={() => handleProductClick(product)}
            />
          ))
        ) : (
          <div className="col-span-full text-center py-10 text-gray-500">
            {searchQuery !== '' ? 
              'Nenhum produto encontrado para esta busca.' : 
              'Nenhum produto encontrado nesta categoria.'}
          </div>
        )}
      </div>
    </div>
  </div>
)};

export default ShopScreen;